import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import {
  fullName,
  email,
  fullContact,
  validString,
  postcode,
  city,
  state,
  country,
} from "Components/shared/helpers/validations";

export const RecipientInfoSchema = Yup.object().shape(
  reverseShape({
    recipientName: fullName.required(),
    recipientEmail: email.optional(),
    contactNo: fullContact.required(),
    street1: validString.required(),
    street2: validString.optional(),
    postcode: postcode.required(),
    city: city.required(),
    state: state.required(),
    country: validString.required(),
    lat: Yup.string()
    .test(
      'is-float',
      'Latitude must be a valid float',
      value => !value || /^[+-]?(\d+\.?\d*|\.\d+)$/.test(value) // Validate float strings
    )
      .optional(),
    lon: Yup.string()
      .test(
        'is-float',
        'Longitude must be a valid float',
        value => !value || /^[+-]?(\d+\.?\d*|\.\d+)$/.test(value)
      )
      .optional(),
  })
);

export default RecipientInfoSchema;
